import { AppBar, Grid, Toolbar } from "@material-ui/core";
import { RootStateOrAny, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import cart from "../../assets/images/cart.png";
import logoLeft from "../../assets/images/rxmediapharma-top-left.png";
import logoRightImage from "../../assets/images/rxmediapharma-top-right-image.png";
import { RxShoppingCartObject } from "../../pages/sale/SalePage";
import { setUserLoggerdOut } from "../../redux/slices/user-slice";
import { store } from "../../redux/store";
import { removeTokens } from "../../utils/AuthFunctions";
import RxCartIcon from "../RxCartIcon";
import RxDropDownMenu from "../RxDropDownMenu";
import RxTypography from "../RxTypography";
import styles from "./RxTopBar.module.css";

const RxTopBar = () => {
	const history = useHistory();

	const userLoggedIn: boolean = useSelector(
		(state: RootStateOrAny) => state.user.userLoggedIn
	);

	const { email, name } = useSelector(
		(state: RootStateOrAny) => state.user.userInfo ?? { email: "", name: "" }
	);

	const cartItem: RxShoppingCartObject = useSelector(
		(state: RootStateOrAny) => state.cart.cartItem
	);

	return (
		<>
			<AppBar position="relative">
				<Toolbar className={styles.toolbar}>
					<Grid container alignItems="center">
						<Grid item xs={12} sm={12} md={6}>
							<img
								alt="RxMediapharma"
								src={logoLeft}
								className={styles.topbarLogo}
								onClick={() => history.push("/")}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={5} container>
							{userLoggedIn && (
								<div className={styles.rightContainer}>
									<RxTypography
										variant="h6"
										align="right"
										label={email}
										className={styles.userContainerRight}
									/>
									<RxDropDownMenu
										items={[
											{
												label: name ? "Sn. " + name : "",
												onClick: () => {},
												className: styles.userEmailInfo,
											},
											{
												label: "seperator",
												onClick: () => {},
												className: styles.seperator,
											},
											{
												label: "Kullanıcı Ayarları",
												className: styles.menuItem,
												onClick: () => {
													history.push("/edit-user");
												},
											},
											{
												label: "Siparişlerim",
												className: styles.menuItem,
												onClick: () => {
													history.push("/order-history");
												},
											},
											{
												label: "Çıkış Yap",
												className: styles.menuItem,
												onClick: () => {
													removeTokens();
													store.dispatch(setUserLoggerdOut());
													history.push("/login");
												},
											},
										]}
										icon={
											<img
												alt="settings"
												src={logoRightImage}
												className={styles.topbarLogo}
											/>
										}
										className={styles.zeroPadding}
									/>
									<RxCartIcon
										img={cart}
										badgeSize={cartItem?.products?.length ?? 0}
										className={styles.cart}
										onClick={() => {
											history.push("/cart");
										}}
									></RxCartIcon>
								</div>
							)}
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
		</>
	);
};

export default RxTopBar;
